import { fmtGHS, fmtDateTime } from "@/lib/format";

const TYPE = { cash: "Cash / walk-in", insurance: "Insurance", corporate: "Corporate" };
const T = ({ head, rows, testId }) => (
  <table className="w-full text-sm" data-testid={testId}>
    <thead className="text-[11px] uppercase text-muted-foreground text-left"><tr>{head.map((h, i) => <th key={h} className={`py-1 ${i ? "text-right" : ""}`}>{h}</th>)}</tr></thead>
    <tbody>{rows}</tbody>
  </table>
);
const td = (v, i) => <td key={i} className={`py-1 ${i ? "text-right font-mono" : ""}`}>{v}</td>;

// Closed-shift sales summary: payment totals, order count per sale type, insurance-scheme and corporate breakdown.
export function ShiftSummary({ shift }) {
  const t = shift?.totals || {};
  return (
    <div className="space-y-4 text-sm" data-testid="shift-summary">
      <div className="text-muted-foreground text-xs">{shift.code} · {shift.shift_label} · {shift.cashier_name} · {shift.branch_name}{shift.closed_at ? ` · closed ${fmtDateTime(shift.closed_at)}` : ""}</div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {[["Cash", t.cash], ["Card", t.card], ["MoMo", t.momo], ["Gross sales", t.gross]].map(([k, v]) => (
          <div key={k} className="rounded-md border border-border p-2"><div className="text-[11px] text-muted-foreground">{k}</div><div className="font-mono font-semibold">{fmtGHS(v || 0)}</div></div>
        ))}
      </div>
      {shift.expected_cash != null && (
        <div className="flex flex-wrap gap-x-6 text-xs"><span>Expected cash {fmtGHS(shift.expected_cash)}</span><span>Counted {fmtGHS(shift.counted_cash)}</span>
          <span className={shift.variance === 0 ? "text-emerald-600" : "text-rose-600"}>Variance {fmtGHS(shift.variance)}</span></div>
      )}
      <div><div className="font-medium mb-1">Orders by sale type</div>
        <T testId="shift-by-type" head={["Type", "Orders", "Value"]} rows={(t.by_type || []).map((r) => <tr key={r.type} className="border-t border-border">{[TYPE[r.type] || r.type, r.count, fmtGHS(r.value)].map(td)}</tr>)} />
        <div className="text-xs text-muted-foreground mt-1">Total orders: {t.sales_count || 0}</div></div>
      <div><div className="font-medium mb-1">Insurance schemes</div>
        {(t.by_scheme || []).length ? <T testId="shift-by-scheme" head={["Scheme", "Orders", "Sales", "Claim", "Client paid"]}
          rows={t.by_scheme.map((r) => <tr key={r.scheme} className="border-t border-border">{[r.scheme, r.count, fmtGHS(r.value), fmtGHS(r.claim), fmtGHS(r.client_paid)].map(td)}</tr>)} />
          : <div className="text-xs text-muted-foreground">No insurance sales</div>}</div>
      <div><div className="font-medium mb-1">Corporate clients</div>
        {(t.by_corporate || []).length ? <T testId="shift-by-corporate" head={["Company", "Orders", "On account"]}
          rows={t.by_corporate.map((r) => <tr key={r.company} className="border-t border-border">{[r.company, r.count, fmtGHS(r.value)].map(td)}</tr>)} />
          : <div className="text-xs text-muted-foreground">No corporate sales</div>}</div>
      {t.inpatient && (
        <div data-testid="shift-inpatient"><div className="font-medium mb-1">Inpatient dispensing</div>
          <T head={["", "Count", "Value"]} rows={<>
            <tr className="border-t border-border">{["Medicines dispensed (not cash)", t.inpatient.dispense_count, fmtGHS(t.inpatient.dispensed_value)].map(td)}</tr>
            <tr className="border-t border-border text-muted-foreground">{[" Patient share", "", fmtGHS(t.inpatient.patient_share)].map(td)}</tr>
            <tr className="border-t border-border text-muted-foreground">{[" Insurance share", "", fmtGHS(t.inpatient.insurance_share)].map(td)}</tr>
            <tr className="border-t border-border text-muted-foreground">{[" Corporate share", "", fmtGHS(t.inpatient.corporate_share)].map(td)}</tr>
            <tr className="border-t border-border" data-testid="shift-inpatient-payments">{["Inpatient payments received (in cash/card/MoMo above)", t.inpatient.payments_count, fmtGHS(t.inpatient.payments_total)].map(td)}</tr>
          </>} />
        </div>
      )}
    </div>
  );
}
